import React, { useState } from 'react'
import CitizenResults from './CitizenResults'
import LawyerResults from './LawyerResults'

/**
 * ResultsShell — Wrapper que permite alternar entre las 3 vistas de resultados
 *
 * Modos:
 *   'citizen' → vista clara para el ciudadano
 *   'lawyer'  → vista oscura profesional para abogados
 *   'classic' → vista actual de la app (children)
 *
 * Props:
 *   @param {'citizen'|'lawyer'|'classic'} defaultMode - modo inicial (opcional, default 'citizen')
 *   @param {Object}  citizenData   — output de useCitizenData()
 *   @param {Object}  lawyerData    — output de useLawyerData()
 *   @param {ReactNode} children    — contenido para la vista "classic" (ResultadosTabBasica actual)
 */
export default function ResultsShell({
  defaultMode = 'citizen',
  citizenData,
  lawyerData,
  children,
}) {
  const [mode, setMode] = useState(defaultMode)

  const tabs = [
    { key: 'citizen', label: 'Vista ciudadano' },
    { key: 'lawyer', label: 'Vista abogado' },
    { key: 'classic', label: 'Vista actual' },
  ]

  return (
    <div className="w-full">
      {/* Toggle bar */}
      <div className="inline-flex rounded-lg border border-gray-700/50 bg-gray-800/30 p-1 mb-6">
        {tabs.map(tab => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setMode(tab.key)}
            className={`px-4 py-2 text-xs font-medium rounded-md transition-all duration-150 cursor-pointer
              ${mode === tab.key
                ? 'bg-blue-600 text-white shadow-sm'
                : 'text-gray-400 hover:text-gray-200'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      {mode === 'citizen' && citizenData && <CitizenResults {...citizenData} />}
      {mode === 'lawyer' && lawyerData && <LawyerResults {...lawyerData} />}
      {mode === 'classic' && children}
    </div>
  )
}
